import { render, staticRenderFns } from "./select-skill.vue?vue&type=template&id=748519b0&"
import script from "./select-skill.vue?vue&type=script&lang=js&"
export * from "./select-skill.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports